import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

const PartnerPerson = ({ person }) => (
  <figure className={styles.person}>
    <img src={person.avatar} alt={person.name} className={styles.person_img} />

    <figcaption className={styles.person_text}>
      <p className={styles.person_text_name}>{person.name}</p>
      <p className={classnames('cr-lead cr-white')}>{person.position}</p>
    </figcaption>
  </figure>
);

export default PartnerPerson;
